module.exports = __webpack_public_path__ + "img/main03.2c954e2d.jpg";